import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_4 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M284.9,432.4c-1.5-8.4-2.9-16.3-4-23c2.5-15.4,3.3-30.2,3.4-41.8c0.1-13,18.3-41.3,17.5-64.6
		c-2.6-78.5,86.2-52.7,99.2-48.5v0.1c13-4.2,101.8-30,99.2,48.5c-0.8,23.3,17.4,51.6,17.5,64.6c0.1,11.4,0.9,26.1,3.3,41.3
		c-1.1,6.7-2.5,14.7-4.1,23.2c2.6,0,5.1,0,7.7,0c3.4-39.3,1.6-157.9,1.6-157.9c0-30.5-26.1-69.7-54.6-81.1
		c-45.4-18.2-96-18.2-141.5,0c-28.5,11.4-54.6,50.6-54.6,81.1c0,0-1.8,119,1.6,158.1C279.8,432.4,282.4,432.4,284.9,432.4z"
        />
        <path
          fill={secondary}
          d="M528.1,146.8c-3-6.1-7.7-13.9-14.1-21.8c4.9,17.7,0.3,35.3,0.3,35.3s2.2-38.6-35-62.8
		c-10.4-6.8-24-8.6-38.9-8.6c0,0,29.8,29.4,33.1,45.3c0,0-12.1-8.2-74.3-48.6c0,0-12.3,21.8,20.2,52.7c0,0-37.9-39.6-89.3-35.1
		c0,0,37.1,25,37.9,39.7c0,0-18.6,3.4-81.3-23.8c0,0-4.2,27.8,39,47c0,0-33.8-13.1-78.7,10.2c0,0,47.4,9.8,53.7,20.8
		c0,0-33.5,6.5-60.5,33.7c0,0,43.6,0,69,37.8c0,0,37.4-36,93.4-7.3c0,0,43-32.5,111.4-27.5C514,233.7,551.3,194.6,528.1,146.8z"
        />
        <path
          fill={primary}
          d="M277,240.4c5.8-5.9,13.1-10.2,20.7-12.9c10.3-3.7,21.2-5,32-6.2c-9.9-11.2-13.6-29.4-26.3-36.4
		c19.6,0.1,39.1,4.2,57.3,11.9c-1.7-14.8-7.8-29-17-39.9c23-0.5,46,9.9,62.1,28.1c0.8-15.6-3.8-31.4-12.7-43.5
		c17.3,5.7,32.7,17.9,43.4,34c4.5-15.4,3-32.7-3.9-46.9c16.6,6,23.6,11.8,34.1,22.1c6.5,6.3,12.4,19.7,14.2,29.1
		c9.7-14.4,20-31.3,16.9-49c9.9,19.3,12.7,43,7.7,64.6c11.7-6,21.9-15.7,29.3-27.4c-1.2-6.8-3.2-13.8-6.8-21.1
		c-3-6.1-7.7-13.9-14.1-21.8c4.9,17.7,0.3,35.3,0.3,35.3s2.2-38.6-35-62.8c-10.4-6.8-24-8.6-38.9-8.6c0,0,29.8,29.4,33.1,45.3
		c0,0-12.1-8.2-74.3-48.6c0,0-12.3,21.8,20.2,52.7c0,0-37.9-39.6-89.3-35.1c0,0,37.1,25,37.9,39.7c0,0-18.6,3.4-81.3-23.8
		c0,0-4.2,27.8,39,47c0,0-33.8-13.1-78.7,10.2c0,0,47.4,9.8,53.7,20.8c0,0-33.5,6.5-60.5,33.7C240.2,230.7,257.7,230.7,277,240.4z"
        />
        <path
          fill={primary}
          d="M461.1,204c2-4.8,1.8-10.5,0.5-15.6c-1.3-5.1-3.7-9.8-6-14.4c1.5,9.1,3.8,19.3,0.7,27.9
		c-2.8,7.7-5.1,12.6-11.7,17.3C452.5,217.5,459.9,206.8,461.1,204z"
        />
        <path
          fill={primary}
          d="M495.2,200.9c1.3-5.5-0.3-11.2-1.9-16.6c-0.9,13.1-7.2,25.5-16.8,33.2c3.9-1.6,7.8-3.3,11.2-5.9
		S494.1,205.4,495.2,200.9z"
        />
        <path
          fill={primary}
          d="M393.2,204.5c-4.1-9.6-8.4-13.5-13.5-19.4c5.6,2,9.8,5.9,13.6,10.9c1.8,2.4,3.5,5.9,4.7,8.7
		c1.1,2.8,1.6,5.9,2,8.9c0.8,6.2-2,18.2-2,18.2C398.2,227.6,397.4,214.4,393.2,204.5z"
        />
        <path
          fill={primary}
          d="M367.5,220.4c-3.3-4-8-6.1-12.6-8c-4.2-1.8-8.4-3.5-12.7-5.3c0,0,7.3,5.5,12.8,9c2.7,1.7,5.6,2.8,8.3,4.5
		c3.4,2.1,7,10.6,9.9,13.4C371.9,229.2,370.6,224.2,367.5,220.4z"
        />
        <path
          fill={primary}
          d="M337.6,238.3c-8.3-5.2-18.4-6.7-27.7-4.2c4.2,1.5,8.4,0.4,12.7,1.7C328.5,237.7,334.5,240,337.6,238.3z"
        />
        <path
          fill={primary}
          d="M416.7,227.4c5.6-5.8,10.2-13.2,11.3-21.5c1.2-8.4-1.6-17.7-8-22.4c3.1,4.8,4.2,15,3.8,21.9
		C423.5,213.4,420.2,222.2,416.7,227.4z"
        />
      </g>
    </>
  );
};

export default Hair_4;
